module.exports = __webpack_public_path__ + "static/10-4dc602a2bd1f2c273162dc6e30e2be58.jpg";